import React, { Component } from 'react';
import axios from 'axios';
import * as $ from 'jquery';
import Payment from './Payment.js';
import { translate } from 'react-i18next';

import ReactGA from 'react-ga';
ReactGA.initialize([
    { trackingId: 'UA-39921274-7', gaOptions: { name: 'IOSOffices' } }
], { debug: false, alwaysSendToDefaultTracker: false });

ReactGA.plugin.require('ec');

let cancelToken;

class SummitPayment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            c_key: "",
            cardCvc: "",
            cardMonth: "",
            cardName: "",
            cardNumber: "",
            cardYear: "",
            city: "",
            country: "",
            error: "",
            isPaying: false,
            neighborhood: "",
            paymentDetails: null,
            po: "",
            promocode: "",
            promocodeError: "",
            state: "",
            street: "",
            isDisabled: false,
            require_invoice: false
        }
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        window.fbq('track', 'AddPaymentInfo');
        this.reload();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.c_key !== this.state.c_key) {
            //window.Conekta.setPublicKey(this.state.c_key)
        }
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
    }

    reload = () => {
        this.getConekta({
            token_id: this.props.getTokenId(),
            razon_social_id: this.props.centro_razonSocial
        });
    }

    // Get Public Key Conekta del centro
    getConekta = (params) => {
        this.props.post(
            "/getConnekta",
            params,
            ({conekta_public_key}) => this.setState({ c_key: conekta_public_key }),
            (error) => this.didGetError(error),
            cancelToken
        );
    }

    didPayInvoice = (response, msg) => {
        window.location.replace("/agradecimiento")
    }

    didGetError = (codigo, errortype, conekta, msg) => {
        $('#modal_colosepayment').click();
        this.setState({ error: msg, isPaying: false, isDisabled: false})
        // alert(msg)
    }

    registerPayment = (params) => {
        //Web service de pago
        this.props.post(
            "/paySummit",
            params,
            (response, msg) => this.didPayInvoice(response, msg),
            (codigo, errortype, conekta, msg) => {
                this.didGetError(codigo, errortype, conekta, msg);
            },
            cancelToken);
    }

    getTokenParams = () => {
        return {
            "card": {
                "number": this.state.cardNumber.trim(),
                "name": this.state.cardName.trim(),
                "exp_year": "20" + this.state.cardYear.trim(),
                "exp_month": this.state.cardMonth.trim(),
                "cvc": this.state.cardCvc.trim(),
                "address": {
                    "street1": this.state.street.trim(),
                    "street2": this.state.neighborhood.trim(),
                    "city": this.state.city.trim(),
                    "state": this.state.state.trim(),
                    "zip": this.state.po.trim(),
                    "country": this.state.country.trim()
                }
            }
        }
    }

    handlePaymentConekta = (params) => {
        const conektaParams = this.getTokenParams();
        this.setState({
            isDisabled: true,
            isPaying: true
        });
        const onSuccess = (token) => this.registerPayment(
            Object.assign({},
                params,
                { token_conekta: token.id })
        );
        const onError = (error) => {
            this.setState({
                isDisabled: false,
                isPaying: false
            });
            alert(error.message + "\n" + error.message_to_purchaser);
        }

        window.Conekta.setPublicKey(this.state.c_key);
        window.Conekta.Token.create(
            conektaParams,
            (token) => onSuccess(token),
            (error) => onError(error)
        );
    }

    handleCardName = (event) => {
        this.setState({ cardName: event.target.value });
    }

    handleCardMonth = (event) => {
        this.setState({ cardMonth: event.target.value });
    }

    handleCardYear = (event) => {
        this.setState({ cardYear: event.target.value });
    }

    handleCardCvc = (event) => {
        this.setState({ cardCvc: event.target.value });
    }

    handleStreetChange = (event) => {
        this.setState({ street: event.target.value });
    }

    handleNeighborhoodChange = (event) => {
        this.setState({ neighborhood: event.target.value });
    }

    handlePoChange = (event) => {
        this.setState({ po: event.target.value });
    }

    handleCityChange = (event) => {
        this.setState({ city: event.target.value });
    }

    handleStateChange = (event) => {
        this.setState({ state: event.target.value });
    }

    handleCountryChange = (event) => {
        this.setState({ country: event.target.value });
    }

    handlePaymentSubmit = (event) => {
        event.preventDefault();

        const params = {
            nombre: this.props.nombre,
            centro_id: this.props.centro_id,
            correo: this.props.correo,
            edad: this.props.edad,
            genero: this.props.genero,
            celular: this.props.celular,
            ciudad: this.props.ciudad,
            empresa: this.props.empresa,
            tipo_empresa: this.props.tipo_empresa,
            puesto: this.props.puesto,
            como_se_entero: this.props.como_se_entero,
            plan_id: this.props.plan_id,
            red_social: this.props.redSocial,
            token_conekta: this.props.token_conekta,
            business_id: this.props.busines,
            promoCode: this.props.promoCode,
            token_id: this.props.getTokenId(),
            require_invoice: this.state.require_invoice
        };
        this.handlePaymentConekta(params);
    }

    handleChecked = (event) => {
        const name = event.target.name;
        this.setState({
            [name]: !this.state[name]
        })
    }


    renderPayment = () => {
        return (
            <Payment
                promoCode={this.props.promoCode}
                cardName={this.state.cardName}
                cardNumber={this.state.cardNumber}
                cardMonth={this.state.cardMonth}
                cardYear={this.state.cardYear}
                cardCvc={this.state.cardCvc}
                street={this.state.street}
                neighborhood={this.state.neighborhood}
                po={this.state.po}
                city={this.state.city}
                country={this.state.country}
                state={this.state.state}
                Isdisabled={this.state.isDisabled}
                isPaying={this.state.isPaying}
                handleCardName={this.handleCardName}
                handleCardNumber={(cardNumber) => this.setState({ cardNumber })}
                handleCardMonth={this.handleCardMonth}
                handleCardYear={this.handleCardYear}
                handleCardCvc={this.handleCardCvc}
                handleStreetChange={this.handleStreetChange}
                handleNeighborhoodChange={this.handleNeighborhoodChange}
                handlePoChange={this.handlePoChange}
                handleCityChange={this.handleCityChange}
                handleStateChange={this.handleStateChange}
                handleCountryChange={this.handleCountryChange}
                handlePaymentSubmit={this.handlePaymentSubmit}
                handleReturn={this.props.handleReturn}
                porcentaje_summit={this.props.porcentaje_summit}
                error={this.state.error}
                handleChecked={this.handleChecked}
            />
        );
    }

    render() {
        // const { t } = this.props;
        return (
            <div className="container-resvations-title">
                {this.renderPayment()}
            </div>
        )

    }

}

export default translate('common')(SummitPayment);



// WEBPACK FOOTER //
// ./src/guest/summit/SummitPayment.js